import app from '../config/firebase';
import { 
  getFirestore, 
  collection, 
  getDocs, 
  query, 
  orderBy,
  doc,
  updateDoc
} from 'firebase/firestore';

const db = getFirestore(app);
const ticketsCollection = collection(db, 'support_tickets');

export const fetchTickets = async () => {
  try {
    // Ordering by createdAt descending to show newest first
    const ticketsQuery = query(ticketsCollection, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(ticketsQuery);

    return snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        userId: data.userId || '',
        email: data.email || '',
        subject: data.subject || 'No subject',
        message: data.message || '',
        status: data.status || 'pending', // Default to pending if missing
        createdAt: data.createdAt || 0,
      };
    });
  } catch (error) {
    console.error('Failed to fetch support tickets:', error);
    throw new Error('Unable to load support tickets from Firestore');
  }
};

export const updateTicketStatus = async (ticketId, newStatus) => {
  if (!ticketId) {
    throw new Error('Ticket ID is required');
  }
  if (!['open', 'pending', 'closed'].includes(newStatus)) {
    throw new Error('Invalid status');
  }

  try {
    const ticketRef = doc(db, 'support_tickets', ticketId);
    await updateDoc(ticketRef, {
      status: newStatus
    });
  } catch (error) {
    console.error(`Failed to update ticket ${ticketId} status:`, error);
    throw new Error('Unable to update ticket status');
  }
};
